import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
            height: '100%',
        },
    }
})

export default useStyles
